import { Stack } from "@mui/material"
import { observer } from "mobx-react"

import { formFields } from "src/modals/knowledge-items/formFields"

export const KnowledgeItemsSettingsSection = observer(() => {
    return (
        <Stack spacing={2}>
            <formFields.KnowledgeItemsAccessGroup />
            <formFields.KnowledgeItemsAgentAccess />
            <formFields.KnowledgeItemsAgentInstances />
            <formFields.KnowledgeItemsType />
            <formFields.KnowledgeItemsTags />
        </Stack>
    )
})
